<button
  hlmCard
  type="button"
  class="create-team-card"
  (click)="create.emit()"
  [attr.aria-label]="label() | translate"
>
  <div hlmCardContent class="create-team-card__content">
    <ocp-themed-icon name="plus-circled.svg" [size]="36" data-test="create-card" />
    <span data-test="create-card-label">{{ label() | translate }}</span>
  </div>
</button>
